export default "__VITE_ASSET__BRFp6$qU__"